export const api = 'https://homevest-api.herokuapp.com'

export let servicingApi
export let firebaseConfig

// if (window.location.hostname === 'homevest.co') {
  servicingApi = 'https://production-servicing.homevest-api.com/v1'
  firebaseConfig = {
    apiKey: 'AIzaSyAv2R_mT-fPORqbPRagCfWT5loMf02PSQo',
    authDomain: 'homevest-production.firebaseapp.com',
    databaseURL: 'https://homevest-production.firebaseio.com',
    projectId: 'homevest-production',
    storageBucket: 'homevest-production.appspot.com'
  }
// } else {
//   servicingApi = 'http://localhost:8080/v1'
//   firebaseConfig = {
//     apiKey: 'AIzaSyC2SEzmEYIIYWDjy1eHZeh8pyhmwS-FaLE',
//     authDomain: 'homevest-development.firebaseapp.com',
//     databaseURL: 'https://homevest-development.firebaseio.com',
//     projectId: 'homevest-development',
//     storageBucket: 'homevest-development.appspot.com'
//   }
// }
